<h1 mat-dialog-title>
    <div class="bulk-ow__title">
        <mat-icon color="warn">warning</mat-icon>
        <span>Bestehende Werte überschreiben?</span>
    </div>
</h1>

<div mat-dialog-content class="bulk-ow__content">
    <p class="bulk-ow__lead">
        Sie speichern Werte für die Liste. Bitte wählen Sie, was mit Tieren passiert, die
        <strong>bereits</strong> ein Gewicht bzw. einen Preis haben.
    </p>

    <ul class="bulk-ow__stats" *ngIf="stats?.length">
        <li *ngFor="let s of stats">
            <strong>{{ s.label }}</strong>
            <br />
            {{ s.filled }} von {{ s.total }} Tieren haben bereits einen Wert
            <span *ngIf="s.filled > 0"> (Summe {{ formatValue(s.filledSum, s.unit) }})</span>
            · {{ s.empty }} ohne Wert
            <div class="bulk-ow__preview" *ngIf="s.perTierAll != null || s.perTierEmptyOnly != null">
                <div *ngIf="s.perTierAll != null">
                    Alle überschreiben → {{ formatValue(s.perTierAll, s.unit) }} je Tier
                </div>
                <div *ngIf="s.perTierEmptyOnly != null">
                    Nur leere befüllen →
                    <ng-container *ngIf="s.remainingForEmpty != null">
                        Rest {{ formatValue(s.remainingForEmpty, s.unit) }} ÷ {{ s.empty }} =
                    </ng-container>
                    {{ formatValue(s.perTierEmptyOnly, s.unit) }} je leerem Tier
                </div>
                <div class="bulk-ow__warn" *ngIf="s.empty > 0 && s.perTierEmptyOnly == null">
                    Rest reicht nicht für die leeren Tiere (Gesamtwert kleiner als Summe der vorhandenen).
                </div>
            </div>
        </li>
    </ul>

    <button type="button" mat-button color="primary" class="bulk-ow__toggle" (click)="showAnimalList = !showAnimalList">
        <mat-icon>{{ showAnimalList ? 'expand_less' : 'expand_more' }}</mat-icon>
        {{ showAnimalList ? 'Tierliste ausblenden' : 'Tierliste anzeigen' }}
    </button>

    <div class="bulk-ow__table-wrap" *ngIf="showAnimalList">
        <table class="bulk-ow__table">
            <thead>
                <tr>
                    <th *ngFor="let col of displayColumns">{{ col.label }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let animal of data.animals">
                    <td *ngFor="let col of displayColumns">{{ formatCell(animal, col.key) }}</td>
                </tr>
            </tbody>
        </table>
        <p class="bulk-ow__hint">./. = kein Wert vorhanden</p>
    </div>

    <p class="bulk-ow__actions-hint">
        <strong>Nur leere befüllen:</strong> vorhandene Werte bleiben; bei Gesamtangabe wird der
        <em>Rest</em> (Gesamt − Summe vorhandener) gleichmäßig auf die leeren Tiere verteilt.
        <br />
        <strong>Alle überschreiben:</strong> jedes Tier erhält denselben Durchschnitt (Gesamt ÷ alle Tiere).
    </p>
</div>

<div mat-dialog-actions class="bulk-ow__actions">
    <button type="button" mat-button data-cy="bulk-overwrite-cancel" (click)="cancel()">Abbrechen</button>
    <div class="bulk-ow__actions-right">
        <button
            type="button"
            mat-stroked-button
            color="warn"
            data-cy="bulk-overwrite-all"
            (click)="choose('all')"
        >
            Alle überschreiben
        </button>
        <button
            type="button"
            mat-flat-button
            color="accent"
            data-cy="bulk-overwrite-empty"
            [disabled]="!canChooseEmptyOnly"
            (click)="choose('empty_only')"
        >
            Nur leere befüllen
        </button>
    </div>
</div>
